<template>
    <span class="dropdown-item">
        <slot/>
    </span>
</template>
<script>
export default {
    name: 'TextDropDownMenuItem'
}
</script>